import i18n from '../../locales/index'
import Icons from './icons.vue'
export default Icons
